<template>
  <div>
    <b-row class="mt-3">
      <b-col cols="4">
        <b-form-group label="Report Type: "  :label-cols="3" >
          <b-form-select class="form-control input" v-model="reportType" disabled>
            <option :value="null"  >--Please Select Type--</option>
              <option value="daywise">Day Wise</option>
            </b-form-select>          
        </b-form-group> 
      </b-col>
      <b-col cols="4">
        <b-form-group label="Hub : "  :label-cols="3" >
          <b-form-select class="form-control input" v-model="destinationhubid" :disabled="isSuperAdmin!=1" @change="changeHubwiseRider">
            <option :value="null"  >--Please Select Hub--</option>
              <option v-for="hub in hublist"   v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
            </b-form-select>          
        </b-form-group> 
      </b-col>
      <b-col cols="4">
        <b-form-group label="Rider : "  :label-cols="3" >
          <ejs-multiselect id='multiselect' placeholder="Select Rider" v-model="value2" :dataSource='options'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
          ></ejs-multiselect>                 
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group label="From Date : "  :label-cols="3" >
          <v-date-picker
            mode="single"
            input-class="dateInput"
            :available-dates="{ start: null, end: new Date() }"
            v-model="fromDate"
          >
          </v-date-picker>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group label="To Date : "  :label-cols="3" >
          <v-date-picker
            mode="single"
            input-class="dateInput"
            :available-dates="{ start: null, end: new Date() }"
            v-model="toDate"
          >
          </v-date-picker>
        </b-form-group>
      </b-col>
      <b-col cols="2" style="text-align:left;">
        <b-form-group>
          <button class="btn btn-primary" @click="getRiderOFDDayWiseListing(1)"> Search </button>                       
          <button class="btn btn-danger ml-1" @click="refresh()"> <i class="fa fa-refresh"></i> </button>                       
        </b-form-group>
      </b-col>
      <b-col cols="2" style="text-align:right;">
          <b-form-group>
            <button class="btn btn-primary" @click="performanceReport" :disabled="totalRows==0">Download </button>                       
          </b-form-group>
      </b-col>
    </b-row> 
    <b-row class="my-2"> 
      <b-col sm="12" class="text-right">
        <b-col sm="12">  
          <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
        </b-col>
      </b-col> 

      <b-col sm="12">
        <b-table 
          show-empty 
          responsive
          :items="items" 
          :busy="isBusy" 
          :current-page="currentPage"
          :fields="fields" 
          :per-page="perPage" 
          :bordered="bordered">

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>

          <template slot="cod_ofd_shipment_count" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'cod_ofd_shipment_count')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.cod_ofd_shipment_count }}</span>
            </button>
          </template>

          <template slot="prepaid_ofd_shipment_count" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'prepaid_ofd_shipment_count')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.prepaid_ofd_shipment_count }}</span>
            </button>
          </template>

          <template slot="total_ofd" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'total_ofd')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.total_ofd }}</span>
            </button>
          </template>

          <template slot="unique_ofd_customer_count" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'unique_ofd_customer_count')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.unique_ofd_customer_count }}</span>
            </button>
          </template>

          <!-- <template slot="ofd_cod" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'ofd_cod')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.ofd_cod }}</span>
            </button>
          </template> -->

          <!-- <template slot="ofd_prepaid" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'ofd_prepaid')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.ofd_prepaid }}</span>
            </button>
          </template> -->

          <!-- <template slot="prepaid_cod_total" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'prepaid_cod_total')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.prepaid_cod_total }}</span>
            </button>
          </template> -->

          <template slot="delivered_shipment_count" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'delivered_shipment_count')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.delivered_shipment_count }}</span>
            </button>
          </template>

          <template slot="undelivered_count" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'undelivered_count')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.undelivered_count }}</span>
            </button>
          </template>

          <template slot="unique_undlv_customer_count" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'unique_undlv_customer_count')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.unique_undlv_customer_count }}</span>
            </button>
          </template>

          <template slot="unique_dlv_customer_count" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'unique_dlv_customer_count')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.unique_dlv_customer_count }}</span>
            </button>
          </template>

          <template slot="first_attempt_delivered_shipment_count" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'first_attempt_delivered_shipment_count')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.first_attempt_delivered_shipment_count }}</span>
            </button>
          </template>

          <template slot="cod_dlv_shipment_count" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'cod_dlv_shipment_count')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.cod_dlv_shipment_count }}</span>
            </button>
          </template>

          <template slot="prepaid_dlv_shipment_count" slot-scope="row">
            <button title="View Details" @click="viewDetails(row.item,'prepaid_dlv_shipment_count')" style="background-color: white !important;" class="btn btn-link">
              <span style="color:#1b8eb7">{{ row.item.prepaid_dlv_shipment_count }}</span>
            </button>
          </template>
        </b-table>
      </b-col> 
      <b-col sm="12" class="my-1" v-if="this.totalRows>10">
        <paginate 
          :page-count="noofpages"
          :page-range="10"
          :margin-pages="2"
          :click-handler="clickCallback"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :container-class="'pagination'"
          :page-class="'page-item'"
          :current-page="currentPage"
        >
        </paginate>
      </b-col> 
      <b-modal size="xl" title="Details" v-model="detailsModal" hide-footer>
        <b-row>
          <b-col sm="12" class="text-right">
            <b-form-group>
              <button class="btn btn-primary" @click="countDetailsReport" :disabled="totalRowsCount==0">Download </button>                       
            </b-form-group>
          </b-col>
          <b-col sm="12" class="text-right">
            <p > <b>Total Records :<span style="color:red;">{{ totalRowsCount }}</span></b> </p>
          </b-col>     
          <b-col sm="12">
            <b-table
              show-empty 
              responsive 
              :items="items1" 
              :busy="isBusy1" 
              :current-page="currentPage1"
              :fields="fields1" 
              :bordered="bordered"
            >

            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>

            </b-table>
          </b-col>
        </b-row>
      </b-modal>
      <b-modal size="xl" title="Customer Details" v-model="customerDetailsModal" hide-footer>
        <b-row>
          <b-col sm="12" class="text-right">
            <p > <b>Total Records :<span style="color:red;">{{ totalCustomerCount }}</span></b> </p>
          </b-col>
          <b-col sm="12">
            <b-table
              show-empty 
              responsive 
              :items="items2" 
              :busy="isBusy2" 
              :current-page="currentPage2"
              :fields="customerFields" 
              :bordered="bordered"
            >

            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>

            <template slot="show_details" slot-scope="row">
              <b-button
              :key=row.item.fcaccountid
                size="sm"
                @click="row.toggleDetails();displayShipmentDetails(row);"
                class="mr-2"
                style="background: #b0c4de !important;color: #000 !important;"
              >
                {{ row.detailsShowing ? "Hide" : "Show" }} Details
              </b-button>
            </template>

            <template slot="row-details" slot-scope="row">
              <b-col sm="12" class="text-right">
                <p > <b>Total Records :<span style="color:red;">{{ totalRowsCount }}</span></b> </p>
              </b-col>
              <b-card title="Shipment Details">
                <b-row>
                  <b-table 
                    show-empty 
                    responsive 
                    :busy="isBusy1"
                    :items="items1"
                    :current-page="currentPage1"
                    :fields="fields1"
                    :bordered="bordered"
                  >
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>

                  </b-table>
                  <b-col sm="12">
                    <div slot="footer" class="text-right">
                      <b-button
                        size="sm"
                        @click="row.toggleDetails"
                        style="background: #b0c4de !important;color: #000 !important;"
                      >Hide Details</b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </template>

            </b-table>
          </b-col>
        </b-row>
      </b-modal>
    </b-row> 
  </div>
</template> 

<script>
import CONSTANTS from '@/utils/constants'
  export default {
    data: function(){
      return{
        name: 'riderWiseOFDReport_KSA',
        isBusy: false,
        items: [],
        // fields: [
        //   {key:'hub_name',label:'Hub Name'},
        //   {key:'driver_name',label:'Driver Name'},
        //   {key:'ofd_date',label:'Date'},
        //   {key:'ofd_shipment_count',label:'OFD Count'},
        //   //{key:'cod_ofd_shipment_count',label:'OFD Count'},
        //   {key:'prepaid_ofd_shipment_count',label:'OFD Prepaid'},
        //   {key:'total_ofd',label:'Total OFD'},
        //   {key:'unique_ofd_customer_count',label:'OFD Customer Count'},
        //   {key:'ofd_cod',label:'COD (Cash on Delivery)'},
        //   {key:'ofd_prepaid',label:'Prepaid'},
        //   {key:'prepaid_cod_total',label:'Total (COD + Prepaid)'},
        //   {key:'delivered_shipment_count',label:'Delivery Count'},
        //   {key:'delivery_percent',label:'Delivery Percentage'},
        //   {key:'undelivered_count',label:'Undelivery Count'},
        //   {key:'cod_ofd_shipment_percent',label:'COD Percentage'},
        //   {key:'prepaid_ofd_shipment_percent',label:'Prepaid Percentage'},
        //   {key:'first_attempt_delivery_percent',label:'First Attempt Delivery Percentage'},
        // ],

        fields: [
          {key:'hub_name',label:'Hub Name'},
          {key:'driver_name',label:'Driver Name'},
          {key:'ofd_date',label:'Date'},
          {key:'total_ofd',label:'Total OFD'},
          {key:'cod_ofd_shipment_count',label:'COD OFD Count'},
          {key:'prepaid_ofd_shipment_count',label:'Prepaid OFD Count'},     
          {key:'unique_ofd_customer_count',label:'OFD Customer Count'},
          {key:'cod_dlv_shipment_count',label:'COD Delivery Count'},
          {key:'prepaid_dlv_shipment_count',label:'Prepaid Delivery Count'},
          {key:'cod_delivery_percent',label:'COD Delivery Percentage'},
          {key:'prepaid_delivery_percent',label:'Prepaid Delivery Percentage'},
          {key:'cod_undelivery_percent',label:'COD Undelivered Percentage'},
          {key:'prepaid_undelivery_percent',label:'Prepaid Undelivered Percentage'},
          {key:'delivered_shipment_count',label:'Total Delivery Count'},
          {key:'undelivered_count',label:'Total Undelivery Count'},
          {key:'unique_undlv_customer_count',label:'Undelivered Customer Count'},
          {key:'unique_dlv_customer_count',label:'Delivered Customer count'},
          {key:'first_attempt_delivered_shipment_count',label:'First Attempt Delivery Count'},
          {key:'delivery_percent',label:'Total Delivery Percentage'},
          {key:'first_attempt_delivery_percent',label:'First Attempt Delivery Percentage'},
        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:10,
        noofpages: 0,
        destinationhubid:null,
        reportType:'daywise',
        hublist:[],
        toDate:new Date(),
        fromDate:new Date(),
        downloadreport:'',
        isSuperAdmin:0,

        //modal fields
        detailsModal:false,
        isBusy1: false,
        items1:[],
        fields1:[
          {key:'shippingid',label:'Shipping Id [Order Id]'},
          {key:'pickuplocationname',label:'Pickup Location Name'},
          {key:'servicetype',label:'Service Type'},
          {key:'shipmentstatus',label:'Shipment Status'},
          {key:'deliverystatus',label:'Delivery Status'},
          {key:'agent_name',label:'Agent Name'},
          {key:'customer_name_no',label:'Customer Name & Mob No.'},
          {key:'vendor_name',label:'Vendor Name'},
          {key:'da_mo_no',label:'DA Mobile Number'},
          {key:'delivery_addr',label:'Delivery Address'},
          {key:'ordertype',label:'Order Type'},
          {key:'createddate',label:'Created Date'},
          {key:'lastmodifieddate',label:'Last Modified Date'}
        ],
        totalRowsCount:0,
        currentPage1: 1,
        perPage1:15,

        //rider dropdown
        pickuplocationpincode:"",
        value2:[],
        agentmaster:[],
        agentfields: { text: 'name', value: 'id' },
        options: [],
        showSelectAll : true,
        allowCustomValue : true,

        //Customer Detail Modal     
        currentOpenFCID: null,  
        customerDetailsModal : false,
        isBusy2: false,
        totalCustomerCount:0,
        currentPage2: 1,
        items2:[],
        customerFields:[
          {key:'customer_name',label:'Customer Name'},
          {key:'customer_mono',label:'Customer No'},
          {key:'delivery_addr',label:'Delivery Address'},
          {key:'show_details',label:'Action'}
        ],
        data:[],
        countName:"",

        //count details download
        downloadcountdetailsreport:'',
      }
    },
    created: function(){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.isSuperAdmin = userInfo.is_superadmin
      var hubId = userInfo.pickuplocationmasterid;
      this.destinationhubid= this.isSuperAdmin != 1 ? hubId : null
      this.getHublist();
      if(this.isSuperAdmin != 1){
        this.pickuplocationpincode = userInfo.pickuplocationpincode
        this.displaydeliveryagent();
      }
      //this.getRiderOFDDayWiseListing(1)
    },

    methods:{
      getHublist: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;
        var hubobj={
          hub_id:currenthub.toString()
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,hubobj)
        .then(result => {
          if(result.body.returnmsg=='Successful'){
            this.hublist = result.body.returnvalue;
          }
        })
        .catch(ex => {
          console.log('error', ex)
        });
      },

      displaydeliveryagent: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        // this.options=[]

        const deliveryagent = {
          deliveryagentpincode: this.pickuplocationpincode,
          isactive: '1',
          hub_id: this.destinationhubid ? this.destinationhubid.toString():""
        
        }
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;
          this.options=[]
          this.value2=[]

          for(var i = 0; i < this.agentmaster.length; i++) {
            var deliveryagent2 = {
              name: this.agentmaster[i].deliveryagentfirstname+" - "+this.agentmaster[i].deliveryagentlastname+" - "+this.agentmaster[i].deliveryagentmasterid,
              id: this.agentmaster[i].deliveryagentmasterid
            }
            this.options.push(deliveryagent2);          
          }

        })
        .catch((ex) => {
          console.log('error', ex)
        })
      },

      changeHubwiseRider: function(selectedHubId){
        this.options=[]
        this.value2=[]
        if(selectedHubId){  
          const selectedHub = this.hublist.find(hub => hub.pickuplocationmasterid === parseInt(selectedHubId));
          this.pickuplocationpincode = selectedHub.pickuplocationpincode
          this.displaydeliveryagent()
        }
      },

      getRiderOFDDayWiseListing: function(pageNo){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        //var hubId = userInfo.pickuplocationmasterid;
        this.isBusy = true;
        var deliveryagentidarr=[];
        deliveryagentidarr=this.value2;
        if(pageNo==1){
          this.items = [];
          this.totalRows = 0;
          this.noofpages = 0;
        }

        if(!this.destinationhubid){
          this.$fire({
            text: "Please Select Hub!!!",
            type: "warning",
            timer: 30000
          }); 
          this.isBusy = false;
          return
        }

        if(this.fromDate > this.toDate){
          this.$fire({
            text: "From date must be smaller than To date",
            type: "warning",
            timer: 30000
          }); 
          this.isBusy = false;
          return
        }
        else{
          const Obj = {
            from_date: this.formatDate(this.fromDate),
            to_date: this.formatDate(this.toDate),
            hub_id: this.destinationhubid ? this.destinationhubid.toString():"",
            // hub_id:"",
            rider_id:deliveryagentidarr,
            limit: this.perPage,
            page_no: pageNo ? pageNo : 1     
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getRiderwiseDaywiseReportListing`,Obj)
          .then(result=>{
            if(result.status==200){
              if(result.body && result.body.returnmsg === 'Successful'){
                this.items = result.body.returnvalue;
                this.totalRows = result.body.totalCount;
                this.noofpages=parseInt(this.totalRows)/this.perPage;
                this.noofpages=Math.ceil( this.noofpages);
                console.log("noofpages-->",this.noofpages)
              }
              else{
                this.items = [];
                this.totalRows = 0;
                this.noofpages = 0;
                this.$fire({
                  text: result.body.returnvalue,
                  type: "warning",
                  timer: 30000
                });
              }
            }else{
              this.items = [];
              this.totalRows = 0;
              this.noofpages = 0;
              this.$fire({
                text: "Error while fetching Data!!!",
                type: "warning",
                timer: 30000
              }); 
            }
            
             this.isBusy = false;
            })
          .catch(ex =>{
            this.items = [];
            this.totalRows = 0;
            this.noofpages = 0;
            this.$fire({
              text: "Error while fetching Data!!!",
              type: "warning",
              timer: 30000
            });
            this.isBusy = false;
            console.log('error',ex)
          })
        }
      },

      performanceReport(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var hubId = userInfo.pickuplocationmasterid;
        var deliveryagentidarr=[];
        deliveryagentidarr=this.value2;

        const Obj={
          from_date: this.formatDate(this.fromDate),
          to_date: this.formatDate(this.toDate),
          hub_id: this.destinationhubid ? this.destinationhubid.toString():"",
          rider_id:deliveryagentidarr,
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getRiderwiseDaywiseReportCsv`,Obj)
        .then(result=>{

          if(result.body){
            this.downloadReport(result.body)
          }
          else{
            this.downloadreport='';
          }
        })
        .catch(ex=>{
          console.log('error',ex)
        })
      },

      downloadReport(data){
        const csvData = data
        console.log("Data for download---> ",csvData);
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + csvData;
        anchor.download = 'riderWiseDayWiseOFDReport.csv';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      },

      viewDetails(data,countName){
        this.data=data
        this.countName=countName
        this.displayRiderOFDDayWiseDetails(data,countName); 
        if(countName=='unique_ofd_customer_count' || countName=='unique_undlv_customer_count' || countName=='unique_dlv_customer_count'){
          // this.data=data
          // this.countName=countName
          this.customerDetailsModal=true
        }else{
          this.detailsModal=true;
        }      
        this.totalRowsCount=0;
        this.totalCustomerCount=0;
      },

    //   toggleDetails(fcid, showhide) {
    //     if (this.currentOpenFCID && this.currentOpenFCID !== fcid) {
    //         const previousItem = this.items2.find(item => item.fcaccountid === this.currentOpenFCID);
    //         if (previousItem) {
    //             previousItem.detailsShowing = false;
    //             this.currentOpenFCID = null; 
    //         }
    //     }

    //     const currentItem = this.items2.find(item => item.fcaccountid === fcid);
    //     if (currentItem) {
    //         if (showhide) {
    //             currentItem.detailsShowing = false;
    //             this.currentOpenFCID = null; 
    //         } else {
    //             currentItem.detailsShowing = true;
    //             this.currentOpenFCID = fcid; 
    //             this.displayShipmentDetails(fcid);
    //         }
    //     }
    //  },

      displayShipmentDetails(row){
        //console.log("row-->",row)

        if (this.currentOpenFCID && this.currentOpenFCID !== row.item.fcaccountid) {
            const previousItem = this.items2.find(item => item.fcaccountid === this.currentOpenFCID);
            if (previousItem) {
              // console.log("previous--->",previousItem)
                previousItem._showDetails = false;
                // this.currentOpenFCID = null; 
            }
        }

          const currentItem = this.items2.find(item => item.fcaccountid === row.item.fcaccountid);
          this.currentOpenFCID = row.item.fcaccountid; 
          // console.log("current fcid-->",this.currentOpenFCID)
          // console.log("currentItem--->",currentItem)


        var showhides=row.detailsShowing
        if(showhides){

        }
        else{
          if(this.countName=='unique_ofd_customer_count'){
            this.displayRiderOFDDayWiseDetails(this.data,"unique_ofd_customer_count_shipment_details",row.item.fcaccountid)
          }
          if(this.countName=='unique_undlv_customer_count'){
            this.displayRiderOFDDayWiseDetails(this.data,"unique_undlv_customer_count_shipment_details",row.item.fcaccountid)
          }
          if(this.countName=='unique_dlv_customer_count'){
            this.displayRiderOFDDayWiseDetails(this.data,"unique_dlv_customer_count_shipment_details",row.item.fcaccountid)
          }
        }
      },

      displayRiderOFDDayWiseDetails:function(data,countName,fcid){
        console.log("details api called")
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        if(countName=='unique_ofd_customer_count' || countName=='unique_undlv_customer_count' || countName=='unique_dlv_customer_count'){
          this.isBusy2 =true;
        }else{
          this.isBusy1 =true;
        }

        const Obj = {
          date : data.ofd_date,
          hub_id : data.hub_id.toString(),
          rider_id : data.ofdriderid.toString(),
          count_name:countName,
          fcaccountid:fcid,
          // downloadAsCSV: 'false'
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDetailsForRiderDaywiseOFDListingCount`,Obj)
        .then(result=>{
          if(result.status==200){
            if(result.body && result.body.returnmsg === 'Successful'){
              if(countName=='unique_ofd_customer_count' || countName=='unique_undlv_customer_count' || countName=='unique_dlv_customer_count'){
                this.items2=result.body.returnvalue;
                this.totalCustomerCount=result.body.returnvalue.length;
              }else{
                this.items1=result.body.returnvalue;
                this.totalRowsCount=result.body.returnvalue.length;
              }                      
              //this.detailsModal=true;
            }
            else{
              //this.detailsModal=false;
              this.items1=[];
              this.totalRowsCount=0;       
              this.$fire({
                text:result.body.returnvalue,
                type: "warning",
                timer: 30000
              }); 
            }
          }else{
            this.items1=[];
            this.totalRowsCount=0; 
            this.$fire({
              text: "Error while fetching Data!!!",
              type: "warning",
              timer: 30000
            }); 
          }
          
          if(countName=='unique_ofd_customer_count' || countName=='unique_undlv_customer_count' || countName=='unique_dlv_customer_count'){
            this.isBusy2 =false;
          }else{
            this.isBusy1 =false;
          }
        })
        .catch(ex=>{
          this.items1=[];
          this.totalRowsCount=0; 
          this.$fire({
            text: "Error while fetching Data!!!",
            type: "warning",
            timer: 30000
          }); 
          if(countName=='unique_ofd_customer_count' || countName=='unique_undlv_customer_count' || countName=='unique_dlv_customer_count'){
            this.isBusy2 =false;
          }else{
            this.isBusy1 =false;
          }
          console.log('error',ex)
        })

      },

      countDetailsReport(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)

        const Obj={
          date : this.data.ofd_date,
          hub_id : this.data.hub_id.toString(),
          rider_id : this.data.ofdriderid.toString(),
          count_name: this.countName,
          downloadAsCSV: 'true'
          // fcaccountid: fcid ? fcid : null
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDetailsForRiderDaywiseOFDListingCount`,Obj)
        .then(result=>{

          if(result.body){
            this.downloadCountReport(result.body)
          }
          else{
            this.downloadcountdetailsreport='';
          }
        })
        .catch(ex=>{
          console.log('error',ex)
        })
      },

      // downloadCountReport(data){
      //   const csvData = data
      //   console.log("Data for download---> ",csvData);
      //   const anchor = document.createElement('a');
      //   anchor.href = 'data:text/csv;charset=utf-8,' + csvData;
      //   anchor.download = 'riderWiseDayWiseOFDReportCountDetails.csv';
      //   document.body.appendChild(anchor);
      //   anchor.click();
      //   document.body.removeChild(anchor);
      // },

      downloadCountReport(data) {
        const csvData = data;
        console.log("Data for download---> ", csvData);

        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const anchor = document.createElement('a');
        const url = URL.createObjectURL(blob);

        anchor.href = url;
        anchor.download = 'riderWiseDayWiseOFDReportCountDetails.csv';

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        URL.revokeObjectURL(url);
      },

      formatDate: function(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
      },

      clickCallback(pageNo){
        this.getRiderOFDDayWiseListing(pageNo)
      },

      refresh(){
        if(this.isSuperAdmin == 1){
          this.destinationhubid=null;
          this.options=[]
          this.value2=[]
        }
        else{
          this.value2=[]
        }
        this.fromDate = new Date();
        this.toDate = new Date();
        this.items = [];
        this.totalRows = 0;
        this.noofpages = 0;
        
        //this.getRiderOFDDayWiseListing(1);
      },
    }
  };
</script>
